import script from "./AdditionalFeaturesModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdditionalFeaturesModal.vue?vue&type=script&setup=true&lang=ts"

import "./AdditionalFeaturesModal.vue?vue&type=style&index=0&id=a84c5b1a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a84c5b1a"]])

export default __exports__